import { api } from './api';

/** Documento de uma das três leituras de selo; só os campos que a coleção usa. */
export interface DocumentoDeSelo {
  behavior?: string;
  /** Imagem personalizada (a moldura com a foto), gerada pelos triggers de `player`. */
  selo?: { url?: string } | null;
}

/** As três leituras de um ciclo (SEL-02), um item da resposta do aggregate `colecao_de_selos`. */
export interface LeiturasDoCiclo {
  ciclo: string;
  cultura: DocumentoDeSelo[];
  galeria: DocumentoDeSelo[];
  realizacao: DocumentoDeSelo[];
}

/**
 * A coleção de selos do funci nos ciclos pedidos, numa requisição só (aggregate `colecao_de_selos`, AJH-49):
 * um item por ciclo. O `Range` é inclusivo e cabe exatamente um item por ciclo (a REST corta em 100 sem ele).
 */
export async function getColecaoDeSelos(ciclos: string[]): Promise<LeiturasDoCiclo[]> {
  if (ciclos.length === 0) return [];

  const { data } = await api.post('find/colecao_de_selos', { ciclos }, { headers: { Range: `items=0-${ciclos.length - 1}` } });
  return Array.isArray(data) ? data : [];
}
